import { Component, OnInit, Renderer2, Input, SimpleChanges, ViewChildren, QueryList } from '@angular/core';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
import Swal from 'sweetalert2';
import { Helpers } from '../../../helpers/helpers';
import { LanguageApp } from '../../../config/datatable-config';
import { OnlinePaymentService } from 'src/app/services/online-payment.service';
import { Select2Data } from 'ng-select2-component';
import { FormControl, FormGroup } from '@angular/forms';
import { RenaultOnlinePaymentDashboard, RenaultOnlinePaymentFilter } from 'src/app/models/renault-online-payment';
import { saveAs } from 'file-saver';
import { NgbDate, NgbCalendar, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
import { UserService } from '../../../services/user.service';



@Component({
  selector: 'app-online-payment',
  templateUrl: './online-payment.component.html',
  styleUrls: ['./online-payment.component.scss']
})
export class OnlinePaymentComponent implements OnInit {

  @ViewChildren(DataTableDirective)
  dtElements: QueryList<DataTableDirective>;
  dtOptions1: any = {};
  dtOptions2: any = {};
  dtTrigger1: Subject<any> = new Subject();
  dtTrigger2: Subject<any> = new Subject();
  listenerFn!: () => void;

  @Input() showDataTable: boolean = false;
  @Input() showDataTableLog: boolean = false;
  @Input() reloadDataTable: boolean;
  @Input() isAdminRenault: boolean;
  @Input() showCif: boolean = false;

  orderDescription: string;

  statusData: Select2Data;
  taxNumberData: Select2Data;
  accountNumberData: Select2Data;
  dataform: FormGroup;
  filter: RenaultOnlinePaymentFilter;
  tableFilter;
  statusDefaultValue: string;
  taxNumberDefaultValue: string;
  accountNumberDefaultValue: string;

  dashboard: RenaultOnlinePaymentDashboard = new RenaultOnlinePaymentDashboard();

  hoveredDate: NgbDate | null = null;

  fromDate: NgbDate | null;
  toDate: NgbDate | null;

  canDownloadExcel = false;


  constructor(private renderer: Renderer2, private helper: Helpers, private service: OnlinePaymentService, private calendar: NgbCalendar, public formatter: NgbDateParserFormatter,
    private userService: UserService) {
    this.fromDate = calendar.getToday();
    this.toDate = calendar.getNext(calendar.getToday(), 'd', 10);
  }

  ngAfterViewInit(): void {
    this.dtTrigger1.next(null);
    this.dtTrigger2.next(null);
    this.listenerFn = this.renderer.listen('document', 'click', (event) => {

      if (event.target.hasAttribute("order-description-id")) {

        this.orderDescription = event.target.getAttribute("order-description-id");

      }

    });
    this.helper.setDataTableSearchDelay();
  }

  ngOnChanges(changes: SimpleChanges): void {

    if (changes["reloadDataTable"] && changes["reloadDataTable"].currentValue == true) {
      this.rerender();
      this.getDashboard();
    }
  }

  ngOnDestroy(): void {
    this.dtTrigger1.unsubscribe();
    this.dtTrigger2.unsubscribe();
    if (this.listenerFn) {
      this.listenerFn();
    }
  }

  rerender(): void {
    const that = this;
    this.dtElements.forEach((dtElement: DataTableDirective) => {
      if (dtElement.dtInstance)
        dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
          dtInstance.destroy();
        });
    });
    this.dtTrigger1.next(null);
    this.dtTrigger2.next(null);
  }

  loadData() {

    this.userService.getUserData().subscribe(resp => {
      if(resp == null) return;
      if (resp.RolesListString.some(x => x == "RedJefeTaller" || x == "RedAsesor" || x == "RedRespMktg")) {
        this.canDownloadExcel = false;
      } else {
        this.canDownloadExcel = true;
      }
    });

    this.service.getStatus().subscribe(resp => {

      let result = [];
      result.push({ value: '0', label: 'Estado de la transferencia**' });
      result.push.apply(result, resp);

      this.statusData = result;

      this.statusDefaultValue = '0';
      this.filter.idStatus = null;

    }, (err) => {
      Swal.fire({
        icon: 'error',
        title: 'Error al recuperar los datos',
        text: 'Ocurrió un error',
            buttonsStyling: false,
            customClass: {
              confirmButton: 'btn btn-outline-secondary'
            },
            confirmButtonText: 'Cerrar'
          });
    });

    this.service.getTaxNumber().subscribe(resp => {

      let result = [];
      result.push({ value: '0', label: 'CIF' });
      result.push.apply(result, resp);

      this.taxNumberData = result;

      this.taxNumberDefaultValue = '0';
      this.filter.taxNumber = null;

    }, (err) => {
      Swal.fire({
        icon: 'error',
        title: 'Error al recuperar los datos',
        text: 'Ocurrió un error',
            buttonsStyling: false,
            customClass: {
              confirmButton: 'btn btn-outline-secondary'
            },
            confirmButtonText: 'Cerrar'
          });
    });

    this.service.getAccountNumber().subscribe(resp => {

      let result = [];
      result.push({ value: '0', label: 'Seleccionar Punto de Red' });
      result.push.apply(result, resp);

      this.accountNumberData = result;

      this.accountNumberDefaultValue = '0';
      this.filter.accountNumber = null;

    }, (err) => {
      Swal.fire({
        icon: 'error',
        title: 'Error al recuperar los datos',
        text: 'Ocurrió un error',
            buttonsStyling: false,
            customClass: {
              confirmButton: 'btn btn-outline-secondary'
            },
            confirmButtonText: 'Cerrar'
          });
    });
  }

  ngOnInit(): void {

    this.filter = new RenaultOnlinePaymentFilter(this.isAdminRenault);
    this.tableFilter = JSON.stringify([this.filter]);
    this.loadData();
    this.getDashboard();

    this.dataform = new FormGroup({
      IdStatus: new FormControl('0'),
      CashoutDateInit: new FormControl(null),
      CashoutDateEnd: new FormControl(null),
      OrderCreationDateInit: new FormControl(null),
      OrderCreationDateEnd: new FormControl(null),
      TaxNumber: new FormControl(null),
      AccountNumber: new FormControl(null),
    });


    this.setDatatable();
    this.setDatatableLog();
  }

  setDatatable() {
    const that = this;
    this.dtOptions1 = {
      ajax: (dataTablesParameters: any, callback) => {
        that.service.getDataTable(dataTablesParameters, this.tableFilter).subscribe(resp => {

          callback({
            recordsTotal: resp.recordsTotal,
            recordsFiltered: resp.recordsFiltered,
            data: resp.data
          });
        }, (err) => {
          Swal.fire({
            icon: 'error',
            title: 'Error al recuperar los datos',
            text: 'Ocurrió un error',
            buttonsStyling: false,
            customClass: {
              confirmButton: 'btn btn-outline-secondary'
            },
            confirmButtonText: 'Cerrar'
          });

        });
      },
      drawCallback: function() {
        that.helper.enableBsTooltips();
      },
      columns: [
        { data: "DealerId" },
        { data: "DealerShortName" },
        { data: "TaxNumber" },
        { data: "CustomerFirstName" },
        { data: "CustomerLastName" },
        { data: "OrderReference" },
        { data: "OrderDescription" },
        { data: "CashoutDate" },
        { data: "CashoutStatus" },
        { data: "CashoutAmount" },
        { data: "OrderCreationDate" },
        { data: "TransferReference" }

      ],
      columnDefs: [
        {
          targets: [6],
          data: "OrderDescription",
          className: "text-center",
          render: function (data, type, full) {
            var retorno = "";
            retorno += '<button order-description-id="' + data + '" type="button" data-bs-toggle="modal" data-bs-target="#modalDescription" class="btn btn-link text-black w-100"><i class="fa fa-comment-o fa-lg" aria-hidden="true"></i></button>';
            return retorno;
          }
        },
        {
          targets: [3, 4],
          className: "bg-light"
        },
        {
          targets: [8],
          data: "CashoutStatus",
          className: "text-center",
          render: function (data, type, full) {
            var retorno = "";
            var bg = "";
            var fa = "";
            if (data == 'EXITOSO') {
              bg = "bg-success";
              fa = "fa-check";
            } else if (data == 'FALLIDO') {
              bg = "bg-danger";
              fa = "fa-exclamation";
            }
            else if (data == 'EN ESPERA') {
              bg = "bg-darkgrey";
              fa = "fa-pause";
            }
            else if (data == 'CANCELADO') {
              bg = "bg-warning";
              fa = "fa-ban";
            }
            retorno += '<div class="' + bg + ' text-white square-md" placement="top" data-bs-toggle="tooltip" data-bs-trigger="hover" data-bs-placement="top" title="' + data + '"><i class="fa ' + fa + '" aria-hidden="true"></i><span class="visually-hidden">' + data + '</span></div>';
            return retorno;
          }
        },
      ],
      responsive: true,
      paging: true,
      pageLength: 10,
      ordering: false,
      lengthChange: false,
      info: false,
      serverSide: true,
      language: LanguageApp.spanish_datatables,
      dom: LanguageApp.custom_dom_datatables,
      processing: true
    };
  }

  setDatatableLog() {
    const that = this;
    this.dtOptions2 = {
      ajax: (dataTablesParameters: any, callback) => {
        that.service.getDataTableLog(dataTablesParameters).subscribe(resp => {

          callback({
            recordsTotal: resp.recordsTotal,
            recordsFiltered: resp.recordsFiltered,
            data: resp.data
          });
        }, (err) => {
          Swal.fire({
            icon: 'error',
            title: 'Error al recuperar los datos',
            text: 'Ocurrió un error',
            buttonsStyling: false,
            customClass: {
              confirmButton: 'btn btn-outline-secondary'
            },
            confirmButtonText: 'Cerrar'
          });

        });
      },
      drawCallback: function() {
        that.helper.enableBsTooltips();
      },
      columns: [
        { data: "CreationDateString" },
        { data: "User", className: "text-start" },
        { data: "TotalAmount", className: "text-end" },
        { data: "TotalCashoutCount" },
        { data: "TotalSucceededCount" },
        { data: "TotalFailedCount" },
        { data: "TotalPendingCount" },
        { data: "TotalCancelledCount" }

      ],
      columnDefs: [

      ],
      searching: false,
      responsive: true,
      paging: true,
      pageLength: 10,
      ordering: false,
      lengthChange: false,
      info: false,
      serverSide: true,
      language: LanguageApp.spanish_datatables,
      dom: LanguageApp.custom_dom_datatables,
      processing: true
    };
  }

  search() {
    this.filter.isAdminRenault = this.isAdminRenault;
    this.filter.idStatus = this.dataform.controls["IdStatus"].value != 0 ? this.dataform.controls["IdStatus"].value : null;
    this.filter.cashoutDateInit = this.dataform.controls["CashoutDateInit"].value;
    this.filter.cashoutDateEnd = this.dataform.controls["CashoutDateEnd"].value;
    this.filter.orderCreationDateInit = this.dataform.controls["OrderCreationDateInit"].value;
    this.filter.orderCreationDateEnd = this.dataform.controls["OrderCreationDateEnd"].value;
    this.filter.taxNumber = this.dataform.controls["TaxNumber"].value != 0 ? this.dataform.controls["TaxNumber"].value : null;
    this.filter.accountNumber = this.dataform.controls["AccountNumber"].value != 0 ? this.dataform.controls["AccountNumber"].value : null;
    this.tableFilter = JSON.stringify([this.filter]);
    this.rerender();
    this.getDashboard();
  }

  resetFilters() {
    this.statusDefaultValue = '0';
    this.taxNumberDefaultValue = '0';
    this.accountNumberDefaultValue = '0';
    this.filter = new RenaultOnlinePaymentFilter(this.isAdminRenault);
    this.tableFilter = JSON.stringify([this.filter]);
    this.dataform.reset();
    this.dataform.controls["IdStatus"].setValue('0');
    this.dataform.controls["TaxNumber"].setValue('0');
    this.dataform.controls["AccountNumber"].setValue('0');
  }

  getDashboard() {

    this.service.getDashboard(this.tableFilter).subscribe(resp => {
      this.dashboard = resp;
    });
  }

  downloadExcel() {

    Swal.fire({
      allowOutsideClick: false,
      icon: 'info',
      text: 'Espere por favor...'
    });

    Swal.showLoading();

    this.service.downloadExcel().subscribe(blob => {
      Swal.close();
      saveAs(blob, "MyPosventa_pagos_online.xlsx");
    }), (err) => {
      Swal.fire({
        icon: 'error',
        title: 'Error al acceder a la BD',
        text: 'Ocurrió un error',
            buttonsStyling: false,
            customClass: {
              confirmButton: 'btn btn-outline-secondary'
            },
            confirmButtonText: 'Cerrar'
          });
    }
  }

  inputDateFocus(input) {
    input.parentElement.classList.remove("hide-date-hint");
    input.parentElement.classList.add("show-date-hint");
  }

  inputDateBlur(input) {
    if (!input.value) {
      input.parentElement.classList.add("hide-date-hint");
      input.parentElement.classList.remove("show-date-hint");
    }
  }

  /* NO BORRAR EJ. RANGO FECHAS PENDIENTE DE IMPLEMENTAR */

  onDateSelection(date: NgbDate) {
    if (!this.fromDate && !this.toDate) {
      this.fromDate = date;
      this["CashoutDateInit"].value = date;
    } else if (this.fromDate && !this.toDate && date && date.after(this.fromDate)) {
      this.toDate = date;
    } else {
      this.toDate = null;
      this.fromDate = date;
    }
  }

  isHovered(date: NgbDate) {
    return this.fromDate && !this.toDate && this.hoveredDate && date.after(this.fromDate) &&
      date.before(this.hoveredDate);
  }

  isInside(date: NgbDate) { return this.toDate && date.after(this.fromDate) && date.before(this.toDate); }

  isRange(date: NgbDate) {
    return date.equals(this.fromDate) || (this.toDate && date.equals(this.toDate)) || this.isInside(date) ||
      this.isHovered(date);
  }

  validateInput(currentValue: NgbDate | null, input: string): NgbDate | null {
    const parsed = this.formatter.parse(input);
    return parsed && this.calendar.isValid(NgbDate.from(parsed)) ? NgbDate.from(parsed) : currentValue;
  }


}
